import React from 'react'
import PropTypes from 'prop-types'
import FAQList from './FAQList'

const FAQNav = props => {
  const { faqs } = props
  return (
    <nav role="navigation" className="mb-16 lg:mb-20">
      <h2 className="uppercase text-xs text-body-light font-semibold mb-3">
        On this page
      </h2>
      <div className="-mx-3">
        <FAQList faqs={faqs} />
      </div>
    </nav>
  )
}

FAQNav.propTypes = {
  FAQs: PropTypes.array,
}

export default FAQNav
